import { useState } from "react";

import { MdChevronRight } from "react-icons/md";
import { Divider } from "@mui/material";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Tabpc from "./Tabpc";
import giaoduc from "../../assets/images/giaoduc.webp";
import ite from "../../assets/images/ite.webp";
import xuhuong_giaoduc from "../../assets/images/xuhuong_giaoduc.webp";
import cdsyte from "../../assets/images/cdsyte.webp";

export default function TimeBody() {
  const [activeTab, setActiveTab] = useState("latest");
  const [currentPage, setCurrentPage] = useState(1);

  // Dữ liệu mẫu cho các bài viết, mỗi bài có đường dẫn riêng
  const articles = [
    {
      id: 1,
      title: "Giải pháp chuyển đổi số giáo dục",
      content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      image: giaoduc,
      category: "Tin tức",
      link: "/giaiphap-chuyendoi-so-giaoduc",
    },
    {
      id: 2,
      title:
        "Giải Pháp Phần Mềm Y Tế: Ứng Dụng Công Nghệ trong Chăm Sóc Sức Khỏe",
      content: "Vestibulum id ligula porta felis euismod semper.",
      image: ite,
      category: "Sự kiện",
      link: "/giaiphap-phanmem-yte",
    },
    {
      id: 3,
      title: "Chuyển Đổi Số Trong Giáo Dục: Xu Hướng Tất Yếu Của Thời Đại",
      content: "Donec ullamcorper nulla non metus auctor fringilla.",
      image: xuhuong_giaoduc,
      category: "Tin tức",
      link: "/chuyendoi-so-giaoduc",
    },
    {
      id: 4,
      title:
        "Chuyển Đổi Số Trong Y Tế: Tương Lai Của Hệ Thống Chăm Sóc Sức Khỏe",
      content: "Donec ullamcorper nulla non metus auctor fringilla.",
      image: cdsyte,
      category: "Tin tức",
      link: "/chuyendoi-so-yte",
    },
    // Thêm nhiều bài viết hơn nếu cần
  ];

  const itemsPerPage = 3;
  const totalPages = Math.ceil(articles.length / itemsPerPage);

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const currentArticles = articles.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="w-full">
      <div className="container mx-auto p-3 block md:hidden lg:hidden">
        <div className="h-[118px] rounded-[16px] w-full bg-white border border-solid border-gray-200">
          {/* Tab header */}
          <div className="w-full h-[59px] bg-[#27C6FF] flex items-center justify-center rounded-t-xl">
            <button
              onClick={() => setActiveTab("latest")}
              className={`text-white px-4 py-2 ${
                activeTab === "latest" ? "font-bold" : ""
              }`}
            >
              Tin mới nhất
            </button>
          </div>

          <div className="flex items-center justify-center w-full">
            <button
              onClick={() => setActiveTab("events")}
              className={`w-1/2 flex items-center justify-center py-3 ${
                activeTab === "events" ? "font-bold" : ""
              }`}
            >
              Sự kiện
            </button>

            <div className="h-14 w-[1px] bg-gray-300"></div>

            <button
              onClick={() => setActiveTab("news")}
              className={`w-1/2 flex items-center justify-center py-3 ${
                activeTab === "news" ? "font-bold" : ""
              }`}
            >
              Tin tức
            </button>
          </div>
        </div>

        <div className="mt-4">
          {activeTab === "latest" && (
            <div className="w-full grid grid-cols-1 gap-4">
              {currentArticles.map((article) => (
                <div
                  key={article.id}
                  className="shadow-custom max-w-full relative rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]"
                >
                  <div>
                    <img
                      src={article.image}
                      alt="img"
                      className="w-full h-auto rounded-t-[20px]"
                    />
                  </div>
                  <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px]">
                    <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] relative bottom-[40px] z-10 flex items-center justify-center">
                      <p className="text-[16px] font-normal text-white">
                        {article.category}
                      </p>
                    </div>
                    <p className="text-[24px] font-semibold text-[#0C5393]">
                      {article.title}
                    </p>
                    <a href={article.link}>
                      <div className="flex items-center gap-2 text-[16px] font-normal text-[#1C9BDB]">
                        <p>Xem chi tiết</p>
                        <MdChevronRight />
                      </div>
                    </a>
                  </div>
                </div>
              ))}
              <Divider />
              <div className="flex items-center justify-center gap-4 py-4 bg-gray-50">
                <button
                  onClick={handlePrevious}
                  disabled={currentPage === 1}
                  className="w-8 h-8 bg-white border border-gray-200 rounded-full flex items-center justify-center shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <FaChevronLeft />
                </button>
                <p className="text-gray-700">
                  Page {currentPage} of {totalPages}
                </p>
                <button
                  onClick={handleNext}
                  disabled={currentPage === totalPages}
                  className="w-8 h-8 bg-white border border-gray-200 rounded-full flex items-center justify-center shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <FaChevronRight />
                </button>
              </div>
            </div>
          )}
          {activeTab === "events" && <p>Nội dung cho Sự kiện</p>}
          {activeTab === "news" && <p>Nội dung cho Tin tức</p>}
        </div>
      </div>
      <div className="container mx-auto p-3 hidden md:block lg:block">
        <Tabpc />
      </div>
    </div>
  );
}
